/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Composer_Locked_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Answer above to continue" |
*
* @param {Onboarding_Composer_Locked_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const onboarding_composer_locked_placeholder = /** @type {((inputs?: Onboarding_Composer_Locked_PlaceholderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Composer_Locked_PlaceholderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Antworte oben, um weiterzumachen")
	return /** @type {LocalizedString} */ ("Answer above to continue")
});